import { render, staticRenderFns } from "./ViewEntity.vue?vue&type=template&id=12c36610&"
import script from "./ViewEntity.vue?vue&type=script&lang=js&"
export * from "./ViewEntity.vue?vue&type=script&lang=js&"
import style0 from "./ViewEntity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports